const strategy = {
  isNonEmpty: function(value, errorMsg) {
    if (value.length === 0) {
      return errorMsg
    }
  },
  length(value, length, errorMsg) {
    if (value.length != length) {
      return errorMsg
    }
  },
  isMobile(value, errorMsg) {
    let reg = /^1[0-9]{10}$/
    if (!reg.test(value)) {
      return errorMsg
    }
  },
}

class Validator {
  constructor() {
    this.cache = []
  }
  add(val, rules) {
    // debugger
    try {
      // 切记一个页面的form ref名称不能一样, 否则验证会冲突
      if (!rules) {
        return false;
      }
       for (let i = 0; i < rules.length; i++) {
      //当为自定义函数时
      if (typeof rules[i].strategy !== "string") {
        strategy["custom" + i] = rules[i].strategy
        function custom(cb) {
          return strategy["custom" + i](val, cb)
        }
        custom.isCustomType = true
        this.cache.push(custom)
        continue
      }

      //   let strategyArr = rules[i].strategy.split(":")
      //   const msg = rules[i].errorMsg

      this.cache.push(function() {
        //   debugger
        let strategyArr = rules[i].strategy.split(":")
        const msg = rules[i].errorMsg || "noText"
        let strate = strategyArr.shift()
        strategyArr.unshift(val)
        strategyArr.push(msg)
        return strategy[strate](...strategyArr)
      })
    }
    } catch (error) {
    console.error("🚀 ~ Validator", error)
      
    }
   
  }
  async start() {
    try {
        //  start() {
    let errorMsg

    for (let i = 0; i < this.cache.length; i++) {
      //为自定义事件时
      if (this.cache[i].isCustomType) {
        await new Promise((resolve) => {
          //执行custom函数
          // debugger

          this.cache[i](function(msg = "") {
            resolve(msg)
          })
        }).then((msg) => {
          errorMsg = msg
        })
      } else {
        errorMsg = this.cache[i]()
      }
      // debugger
      if (errorMsg) {
        this.cache = []
        if (errorMsg === "noText") return "error"
        return errorMsg
      }
      // else {
      //   return 'error'
      // }
    }
    this.cache = []
    // 没错反false
    return false
    } catch (error) {
    console.error("🚀 ~ Validator", error)
      
    }
  
  
  }
}
export default new Validator()
